import _tslib from "tslib";
import { dew as _formDew } from "./form";
import { dew as _textDew } from "./text";
import { dew as _colorsDew } from "./colors";
import { dew as _errorsDew } from "./errors";
import { dew as _objectsDew } from "./objects";
import { dew as _operationsDew } from "./operations";
import { dew as _operatorsDew } from "./operators";
import { dew as _rotationsDew } from "./rotations";
import { dew as _sizesDew } from "./sizes";
import { dew as _PDFPageOptionsDew } from "./PDFPageOptions";
import { dew as _PDFDocumentOptionsDew } from "./PDFDocumentOptions";
import { dew as _StandardFontsDew } from "./StandardFonts";
import { dew as _PDFDocumentDew } from "./PDFDocument";
import { dew as _PDFFontDew } from "./PDFFont";
import { dew as _PDFImageDew } from "./PDFImage";
import { dew as _PDFPageDew } from "./PDFPage";
import { dew as _PDFEmbeddedPageDew } from "./PDFEmbeddedPage";
import { dew as _PDFJavaScriptDew } from "./PDFJavaScript";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var tslib_1 = _tslib;

  tslib_1.__exportStar(_formDew(), exports);

  tslib_1.__exportStar(_textDew(), exports);

  tslib_1.__exportStar(_colorsDew(), exports);

  tslib_1.__exportStar(_errorsDew(), exports);

  tslib_1.__exportStar(_objectsDew(), exports);

  tslib_1.__exportStar(_operationsDew(), exports);

  tslib_1.__exportStar(_operatorsDew(), exports);

  tslib_1.__exportStar(_rotationsDew(), exports);

  tslib_1.__exportStar(_sizesDew(), exports);

  tslib_1.__exportStar(_PDFPageOptionsDew(), exports);

  tslib_1.__exportStar(_PDFDocumentOptionsDew(), exports);

  tslib_1.__exportStar(_StandardFontsDew(), exports);

  var PDFDocument_1 = _PDFDocumentDew();

  Object.defineProperty(exports, "PDFDocument", {
    enumerable: true,
    get: function () {
      return PDFDocument_1.default;
    }
  });

  var PDFFont_1 = _PDFFontDew();

  Object.defineProperty(exports, "PDFFont", {
    enumerable: true,
    get: function () {
      return PDFFont_1.default;
    }
  });

  var PDFImage_1 = _PDFImageDew();

  Object.defineProperty(exports, "PDFImage", {
    enumerable: true,
    get: function () {
      return PDFImage_1.default;
    }
  });

  var PDFPage_1 = _PDFPageDew();

  Object.defineProperty(exports, "PDFPage", {
    enumerable: true,
    get: function () {
      return PDFPage_1.default;
    }
  });

  var PDFEmbeddedPage_1 = _PDFEmbeddedPageDew();

  Object.defineProperty(exports, "PDFEmbeddedPage", {
    enumerable: true,
    get: function () {
      return PDFEmbeddedPage_1.default;
    }
  });

  var PDFJavaScript_1 = _PDFJavaScriptDew();

  Object.defineProperty(exports, "PDFJavaScript", {
    enumerable: true,
    get: function () {
      return PDFJavaScript_1.default;
    }
  }); //# sourceMappingURL=index.js.map

  return exports;
}